<div class="side-nav-menu">
  @if (loadingMenu) {
    <span class="fa fa-spinner list-spinner"></span>
  } @else {
    <p-accordion [multiple]="true" [selectOnFocus]="isUser">
      @for (item of activeItems; track item.Label; let i = $index) {
        <p-accordion-panel [value]="i">
          <p-accordion-header>{{ item.Label.toUpperCase() }}</p-accordion-header>
          <p-accordion-content>
            @for (subItem of item.Items; track subItem.Label; let si = $index) {
              @if (subItem.Items) {
                <p-accordion [multiple]="true">
                  <p-accordion-panel [value]="si">
                    <p-accordion-header>{{ subItem.Label.toUpperCase() }}</p-accordion-header>
                    <p-accordion-content>
                      <div class="menu-item">
                        @for (subSubItem of subItem.Items; track subSubItem.Label) {
                          @if (!subSubItem.Disabled) {
                            <a (click)="goToRoute(subSubItem.Route)">
                              <span class="{{subSubItem.Icon}}"></span>
                              <span> {{ subSubItem.Label | labelReplace }}</span>
                            </a>
                          }
                        }
                      </div>
                    </p-accordion-content>
                  </p-accordion-panel>
                </p-accordion>
              }
            }
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>
